var POPOVER_POSITION_TOP = "top",
  POPOVER_POSITION_BOTTOM = "bottom",
  POPOVER_POSITION_LEFT = "left",
  POPOVER_POSITION_RIGHT = "right";

var SvgPopoverMixin = {

  statics: {
    POPOVER_POSITION_TOP: POPOVER_POSITION_TOP,
    POPOVER_POSITION_BOTTOM: POPOVER_POSITION_BOTTOM,
    POPOVER_POSITION_LEFT: POPOVER_POSITION_LEFT,
    POPOVER_POSITION_RIGHT: POPOVER_POSITION_RIGHT
  },

  /** Resolve popover drawing area coordinates */
  getPopoverRect(x, y, width, height){
    var relativeWidth = this.context.relativeX(width),
      relativeHeight = this.context.relativeY(height),
      capWidth = 0.1 * relativeWidth, capHeight = 0.1 * relativeHeight,
      x1, y1, x2, y2, position, tempObj;

    if ((y - relativeHeight) > 0) {
      y1 = y - relativeHeight;
      y2 = y;
      position = POPOVER_POSITION_TOP;
    } else if ((y + relativeHeight) < this.context.height) {
      y1 = y;
      y2 = y + relativeHeight;
      position = POPOVER_POSITION_BOTTOM;
    } else {
      y1 = 0;
      y2 = relativeHeight;
    }

    if (position == POPOVER_POSITION_TOP || position == POPOVER_POSITION_BOTTOM) {
      x1 = x - relativeWidth / 2;
      x2 = x + relativeWidth / 2;

      if (x1 < 0) {
        x2 = x2 + Math.abs(x1);
        x1 = 0;
      } else if (x2 > this.context.width) {
        x1 = x1 - (x2 - this.context.width);
        x2 = this.context.width;
      }
    } else {
      if (x - relativeWidth > 0) {
        x1 = x - relativeWidth;
        x2 = x;
        position = POPOVER_POSITION_LEFT;
      } else {
        x1 = x;
        x2 = x + relativeWidth;
        position = POPOVER_POSITION_RIGHT;
      }
    }

    return {
      x1: x1, y1: y1,
      x2: x2, y2: y2,
      x: x, y: y,
      width: relativeWidth, height: relativeHeight,
      capWidth: capWidth, capHeight: capHeight,
      position: position
    };
  },

  /** return popover path */
  getPopoverLinePath(popoverRect){
    var {x1, y1, x2, y2, x, y, width, height, position, capWidth, capHeight} = popoverRect;

    var margin = position == POPOVER_POSITION_TOP
      || position == POPOVER_POSITION_BOTTOM
        ? height * 0.05
        : width * 0.05,
      dx, dy,
      cx1, cy1, cx2, cy2,
      path = [];

    switch (position) {
      case POPOVER_POSITION_TOP:
        dx = 0;
        dy = -margin;
        cx1 = x - capWidth / 2;
        cx2 = x + capWidth / 2;
        if (cx1 < x1) {
          cx1 = x1;
          cx2 = x1 + capWidth;
        } else if (cx2 > x2) {
          cx1 = x2 - capWidth;
          cx2 = x2;
        }
        cy1 = cy2 = y - capHeight;
        path.push([x + dx, y + dy]);
        path.push([cx1 + dx, cy1 + dy]);
        path.push([x1 + dx, cy1 + dy]);
        path.push([x1 + dx, y1 + dy]);
        path.push([x2 + dx, y1 + dy]);
        path.push([x2 + dx, cy2 + dy]);
        path.push([cx2 + dx, cy2 + dy]);
        path.push([x + dx, y + dy]);
        break;
      case POPOVER_POSITION_BOTTOM:
        dx = 0;
        dy = margin;
        cx1 = x - capWidth / 2;
        cx2 = x + capWidth / 2;
        if (cx1 < x1) {
          cx1 = x1;
          cx2 = x1 + capWidth;
        } else if (cx2 > x2) {
          cx1 = x2 - capWidth;
          cx2 = x2;
        }
        cy1 = cy2 = y + capHeight;
        path.push([x + dx, y + dy]);
        path.push([cx1 + dx, cy1 + dy]);
        path.push([x1 + dx, cy1 + dy]);
        path.push([x1 + dx, y2 + dy]);
        path.push([x2 + dx, y2 + dy]);
        path.push([x2 + dx, cy2 + dy]);
        path.push([cx2 + dx, cy2 + dy]);
        path.push([x + dx, y + dy]);
        break;
      case POPOVER_POSITION_LEFT:
        dx = -margin;
        dy = 0;
        cx1 = cx2 = x - capWidth;
        cy1 = y - capHeight / 2;
        cy2 = y + capHeight / 2;
        path.push([x + dx, y + dy]);
        path.push([cx1 + dx, cy1 + dy]);
        path.push([cx1 + dx, y1 + dy]);
        path.push([x1 + dx, y1 + dy]);
        path.push([x1 + dx, y2 + dy]);
        path.push([cx2 + dx, y2 + dy]);
        path.push([cx2 + dx, cy2 + dy]);
        path.push([x + dx, y + dy]);
        break;
      case POPOVER_POSITION_RIGHT:
        dx = margin;
        dy = 0;
        cx1 = cx2 = x + capWidth;
        cy1 = y - capHeight / 2;
        cy2 = y + capHeight / 2;
        path.push([x + dx, y + dy]);
        path.push([cx1 + dx, cy1 + dy]);
        path.push([cx1 + dx, y1 + dy]);
        path.push([x2 + dx, y1 + dy]);
        path.push([x2 + dx, y2 + dy]);
        path.push([cx2 + dx, y2 + dy]);
        path.push([cx2 + dx, cy2 + dy]);
        path.push([x + dx, y + dy]);
        break;
    }

    return path;
  }


};


module.exports = SvgPopoverMixin;
